<template>
    <div class="card">
        <div class="row mt-2">
                <div class="col-lg-11 col-11 mx-auto">
                    <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                                    style="background: url('/assets/images/pexels-pixabay-Snow-Mountain2000fshead.png')  center;">
                                    <h3 class="widget-user-username text-left">Stop Self-Sabotage.</h3>
                                    <h2 class="widget-user-desc text-right">Overcome your Demons.</h2>
                                    <h3 class="widget-user-username text-right">Conquer the Past.</h3>
                                </div>
                                <div class="widget-user-image">
                                    <img class="img-circle" src="/assets/images/pexels-rodnae-productions-7005569_winner128x128.png" alt="User Avatar">
                                </div>
                    </div>
                </div>
        </div>

    <div class="card-body" style="background:#ddd;">
        <div class="col-12 text-center">
            <h2>Your Eliminate Self-Sabotage Dashboard</h2>
        </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 bordered">
                <div class="color-palette-set">
                    <div class="col-lg-6 col-6 mx-auto m-2">
                <div class="row mt-2 justify-content-between">
                        <button v-for="(vido, index) in video" :key="index" class="col btn-sm bg-warning" @click="showVideoModal(index)">{{videoTitle[index]}} &nbsp;<i class="fa fa-tv"></i></button>
                        <button class="col btn-sm bg-primary" @click="newKSSSetup">Analyse a Self-Sabotage Habit&nbsp;<i class="fas fa-plus"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

       <div class="row">
              <div class="col-sm-12 col-md-12 bordered">
                <div class="color-palette-set">
                    <div class="col-lg-6 col-6 mx-auto m-2">
                        <div class="row mt-2 justify-content-center">
                        <div v-if="kssData.length>0">
                            <select  v-model="currentkssid" @change="setSelKSS()">
                                <option value="">Select a Self-Sabotage habit to track or review performance</option>
                                <option v-for="kss in kssData" :value="kss.id" :key="kss.id">{{kss.name}}
                                    <!-- ({{habit.description}}) REMOVED TO FIT MOBILE-->
                                </option>
                            </select>
                            <!-- <button :disabled="currenthabitid ==''" class="btn btn-sm bg-light float-right" @click="displayTrackerModal()">Track My Performance &nbsp;<i class="fas fa-shoe-prints"></i></button>
                            <button :disabled="currenthabitid ==''" class="btn btn-sm bg-light float-right" @click="displayResultsModal()">Review My Performance &nbsp;<i class="fa fa-eye"></i></button>
                        -->
                        </div>
                          <div v-if="kssData.length<1">
                           Please set up one or more Self-Sabotage habits to eliminate.
                        </div>
                     </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="currentkssdata!=''" class="row mt-2 justify-content-center">
        <div class="content-box-gray card" >
            <div class="title text-center">
                <h5 class="mt-2" style="margin:auto;" >{{currentkssdata.name}}</h5>
            </div>
            <div class="content justify-content-center">
                <button :disabled="currentkssid ==''" class="btn btn-sm bg-light float-right" @click="trackKSS()">Track My Focus &nbsp;<i class="fas fa-shoe-prints"></i></button>
                <button :disabled="currentkssid ==''" class="btn btn-sm bg-light float-right" @click="displayKSSResultsModal()">Review My Focus &nbsp;<i class="fa fa-eye"></i></button>
            </div>
        </div>
    </div>
</div>


</div>

       </div>
    </div>
</template>

<script>
import axios from 'axios';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../event-bus';
import { v4 as uuidv4 } from 'uuid';

export default {
    components: { Errors,
         },
    name: "KillSelfSabotageDash",
    data() {
        return {
            userdata:[],
            currentkssid:'',
            currentkssdata:'',
            habit:'',
            errors: {
                nahme: '',
                message: '',
                    },
            ksstrackingdata:[],
            kssData:[],
            video:[],
            videoSrc: [],
            videoDuration: [],
            videoTitle:[]
        }
    },
    props: {
        user:'',
        kss:[],
        tracking:[],
        videolinks:'',
    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.kssData= JSON.parse(this.kss);
        this.ksstrackingdata = JSON.parse(this.tracking);
        this.currentkssdata = '';
        this.videoData = JSON.parse(this.videolinks);
        this.thisComponentName = this.$options.name;
        this.setupVideo();
    },

    methods: {
        showVideoModal(index){
            const payload = {title:"Eliminate Self-Sabotage.",
            videourl: this.videoSrc[index],
            displayText: this.videoText};
            EventBus.$emit('displayVideoModal', payload);
        },
        setupVideo() {
            var videoNum = 0;
            const siteVideoName = this.thisComponentName + "_video";
            console.log(`Looking for ${siteVideoName}`);
            this.videoData.forEach(video => {
                const videoName = video.name;
                const vidUrl = video.url;
                const vidDuration = video.duration;
                console.log(`${videoName}, ${vidUrl}, ${vidDuration}`);
                    if(videoName == siteVideoName) {
                        console.log(`Found it: ${videoName}, ${vidUrl}, ${vidDuration}`);
                        this.video[videoNum] = video;
                        this.videoSrc[videoNum] = vidUrl;
                        this.videoDuration[videoNum] = vidDuration;
                        this.videoTitle[videoNum] = video.title;
                        videoNum++;
                    }
            });
        },
        trackKSS(kss_id) {
            console.error('trackKSS called.....');
            var selKSSData = this.getKSSData(this.currentkssid);
            var data = {kssdata: selKSSData, userdata:this.userdata }
            EventBus.$emit('displayKSSTrackerModal', data);
        },



        getKSSData(habit_id) {
            console.log("Looking for KSS with id: " + habit_id);
            var retVal = '';
            this.kssData.forEach((aHabit)=>{
                // console.log(aHabit.name + aHabit.id);
                if(aHabit.id == habit_id)  {
                    console.log("Found KSS: " + aHabit.name);
                    retVal =  aHabit;
                }
            });
            return retVal;
        },

        displayKSSResultsModal(){
            var selKSSData = this.getKSSData(this.currentkssid);
            var selKSSTracking = this.getKSSTrackingData(this.currentkssid);
            // console.error(this.actionhabittrackingdata);
            var data = {kssdata: selKSSData,
                        userdata:  this.userdata,
                        ksstrakkerdata:  selKSSTracking,
                        };
            EventBus.$emit('displayKSSResultsModal', data);
        },

        getKSSTrackingData(kill_selfsabotage_id) {
            var retVal = [];
            [...this.ksstrackingdata].forEach((aTrackingData)=>{
                if(aTrackingData.kill_selfsabotage_id == kill_selfsabotage_id) {
                    // console.log("Found: " + aTrackingData.attempt_count + ' ' + aTrackingData.streak + ' ' + aTrackingData.id);
                    retVal.push(aTrackingData);
                }
            });
            return retVal;
        },

        // displayKSSModal(){
        //     const payload = {KSSdata:  this.currentkssdata, userdata: this.userdata};
        //     EventBus.$emit('displayKSSTrackerModal', payload);
        // },

        newKSSSetup(){
            window.location.replace('/eliminatess/setup');
        },

        showReview(){
            window.location.replace('/eliminatess/review/' + this.currenthabitid);
        },

        displayModal(){
            const payload ={title:  "Video Title goes here", videourl: ''};
            EventBus.$emit('displayVideoModal', payload);
        },

        setSelKSS() {
            var selKSS = '';
            selKSS = [...this.kssData].filter((aKSS)=> {
                        if( aKSS.id == this.currentkssid) return aKSS;
                });
            // console.log(selHabit);
            this.currentkssdata = selKSS[0];
            // return selHabit[0];
        },

        track() {
            window.location.replace('/eliminatess/track/' + this.currentkssid);
        }



    }


}
</script>

<style scoped>
.habit-page {
  -ms-flex-align: center;
  align-items: center;
  background: #e9ecef;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  -ms-flex-pack: center;
  justify-content: center;
}
.habit-box {
  width: 540px;

}

.habit-card-body {
  background: #eee;
  border-top: 0;
  color: #666;
  padding: 20px;
}
.habit-card-sub-body {
    width:80%;
    border:3px solid #fff;
    background: rgb(209, 219, 248);
    border-top: 1em;
    margin: 4.4em;
    color: #666;
    padding: 20px;
    border-radius:4px;/*2em 2em 0em 0em;*/
    box-shadow: #ddd 4px 4px 4px;
}
.input-group{
margin-bottom:.4em;
}

.btn-container{
display:flex;
margin:1em;
}
a, button {
margin-left:auto;
}
.div-box{
margin: 2em;
padding: 2em;
border: solid 1px #fff;
box-shadow: 4px 4px 4px #666;
 border-radius:2em 2em 0em 0em;
}
.customElements{
margin: 2em;
padding: 2em;
border: solid  1px #fff;
border-radius:2em 2em 0em 0em;
box-shadow: 4px 4px 4px #666;
}
.header-box-msg, .habit-table-head{
padding:.75em;
background:#343a40;
color:#ffc107;
}
.tracker-btn{
    margin-top: .5em;
    margin-bottom: .5em;
    margin-left:1em;
    /* margin-right:1em; */
    width:80%;
    padding: .5em;
    /* align-content: center; */
}
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}




.mobile-first,
.desktop-first {
  padding: 1em;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
  margin: 2em auto;
  max-width: 750px;
}

/*  mobile-first */
@media (min-width: 600px) {
  .mobile-first .sales-points {
    display: flex;
    justify-content: space-between;
  }

  .mobile-first .sales-point {
    width: 30%;
  }
}

/* desktop first */
.desktop-first .sales-points {
  display: flex;
  justify-content: space-between;
}

.desktop-first .sales-point {
  width: 30%;
}

@media (max-width: 600px) {
  .desktop-first .sales-points {
    display: block;
  }

  .desktop-first .sales-point {
    width: 100%;
  }
}

.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#876759;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}







</style>
